<template>
  <div class="container pl-10 pr-10 pt-10">
    <div class="row pl-3 pr-3">
      <b-button
        :disabled="userPermissions.totalControl === 0"
        v-has-permission="'ED089'"
        class="mr-3 btn-icon"
        :class="{ 'cursor-not-allowed': userPermissions.totalControl === 0 }"
        v-tooltip="'Dar permisos'"
        @click="newPermission"
        variant="primary"
        data-cy="give-permission"
      >
        <feather-icon icon="ShieldIcon" />
      </b-button>
    </div>
    <table
      class="table b-table mt-5 mb-0"
      v-show="!loading"
    >
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Lectura</th>
          <th scope="col">Escritura</th>
          <th scope="col">Control Total</th>
          <th scope="col" v-if="getSelectedElement.type === 'folder'">Hereda permisos</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody v-show="loading === false">
        <tr
        data-cy="permission-line"
        v-for="(permission, index) in permissionsList"
        :key="`permission_${index}`"
        >
          <td>
            <b-avatar
              class="mr-3"
              :icon="permission.tipoEntidad === 'G' ? 'people-fill' : ''"
              :src="permission.avatar"
              variant="secondary"
              v-tooltip="permission.nombreEntidad"
            />
            {{ permission.nombreEntidad }}
          </td>
          <td>
            <b-form-checkbox
              v-model="permission.lectura"
              value="1"
              unchecked-value="0"
              disabled
            />
          </td>
          <td>
            <b-form-checkbox
              v-model="permission.escritura"
              value="1"
              unchecked-value="0"
              disabled
            />
          </td>
          <td>
            <b-form-checkbox
              v-model="permission.controlTotal"
              value="1"
              unchecked-value="0"
              disabled
            />
          </td>
          <td  v-if="getSelectedElement.type === 'folder'">
            <b-form-checkbox
              v-model="permission.todoPermisos === 'Y' ? 1 : 0"
              value="1"
              unchecked-value="0"
              disabled
            />
          </td>
          <td>
            <b-button-group>
              <b-dropdown
                v-if="permission.idEntidad !== currentUser.id
                  && userPermissions.totalControl === 1
                  || getSelectedElement.ownerId !== currentUser.id
                  && userPermissions.totalControl === 1"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                text="Acciones"
                data-cy="actions"
                variant="outline-primary"
                size="sm"
              >
                <b-dropdown-item
                  @click="editPermission(index)"
                  v-has-permission="'ED090'"
                >
                  <feather-icon
                    class="text-success"
                    icon="EditIcon"
                  /> Editar
                </b-dropdown-item>
                <b-dropdown-item
                  @click="deletePermission(index)"
                  v-has-permission="'ED091'"
                  v-if="permission.idEntidad !== currentUser.id"
                >
                  <feather-icon
                    class="text-danger"
                    icon="Trash2Icon"
                  /> Eliminar
                </b-dropdown-item>
              </b-dropdown>
            </b-button-group>
          </td>
        </tr>
      </tbody>
      <tbody v-show="loading === true">
        <tr>
          <td><b-skeleton animation="fade" type="avatar"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"></td>
        </tr>
        <tr>
          <td><b-skeleton animation="fade" type="avatar"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"><b-skeleton animation="fade"/></td>
          <td class="pt-10"></td>
        </tr>
      </tbody>
    </table>
    <!-- PERMISSIONS FORM -->
    <EDPermissionsForm
      @update-permissions="setPermissions"
      v-if="modalName"
      :selectedPermission="selectedPermission"
      :element="getSelectedElement"
      :list="permissionsList"
      :loadPermissions="loadPermissions"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import {
  ioEDPermissionsDelete
} from '@/febos/servicios/api/repositories.api';
import EDPermissionsForm from '@/febos/global/documentManagement/vistas/modals/EDPermissionsForm';

export default {
  name: 'PermissionsView',
  data() {
    return {
      userPermissions: {
        read: 0,
        write: 0,
        totalControl: 0
      },
      permissionsList: [],
      loading: false,
      selectedPermission: null
    };
  },
  components: {
    EDPermissionsForm
  },
  watch: {
    async getSelectedElement() {
      await this.loadPermissions();
      this.loadUserPermissions();
    },
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('DocManagement', [
      'loadPermissionsElement'
    ]),
    async loadPermissions() {
      this.loading = true;
      await this.loadPermissionsElement({
        elementId: this.getSelectedElement.id,
        repositoryId: this.getSelectedElement.repositoryId
      });
      this.permissionsList = this.getPermissionsStack[this.getSelectedElement.id];
      this.loading = false;
    },
    editPermission(index) {
      this.selectedPermission = this.permissionsList[index];
      this.showModals('EDPermissionsForm');
    },
    setPermissions() {
      this.loadPermissions();
    },
    async deletePermission(index) {
      const response = await ioEDPermissionsDelete({
        elementId: this.getSelectedElement.id,
        repositoryId: this.getSelectedElement.repositoryId,
        permissionId: this.permissionsList[index].permisoId
      });
      this.permissionsList.splice(index, 1);
      if (response && response.data && response.data.tareaId) {
        this.$root.$bvToast.toast(
          'Los permisos se están eliminando de las subcarpetas. Te notificaremos por correo cuando termine.',
          { title: 'Eliminación en proceso', variant: 'info', solid: true, autoHideDelay: 5000 }
        );
      }
    },
    newPermission() {
      this.selectedPermission = null;
      this.showModals('EDPermissionsForm');
    },
    loadUserPermissions() {
      const selected = this.getSelectedElement;
      this.userPermissions.read = selected.loggedUserPermissions.lectura;
      this.userPermissions.write = selected.loggedUserPermissions.escritura;
      this.userPermissions.totalControl = selected.loggedUserPermissions.controlTotal;
    }
  },
  mounted() {
    this.loadPermissions();
    this.loadUserPermissions();
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedElement',
      'getPermissionsStack'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    fieldsTitle() {
      if (this.getSelectedElement.type === 'folder') {
        return ['lectura', 'escritura', 'control total', 'heredar permisos'];
      }
      return ['lectura', 'escritura', 'control total'];
    }

  }
};
</script>
